import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class FilterService {

  constructor(private http: HttpClient) { }

  getTraining(type:string): Observable<any> {
    return this.http
      .get(
        `/api/v1/admin/filter/training/${type}`
      );
  }

  newTraining(type: string, key: string, value: string): Observable<any> {
    return this.http
      .post(
        `/api/v1/admin/filter/training`,
        JSON.stringify({ type: type, k: key, v: value })
      );
  }

  deleteTraining(id: string): Observable<any> {
    return this.http
      .delete(
        `/api/v1/admin/filter/training/${id}`
      );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/filter.service.ts